module.exports = __webpack_public_path__ + "img/solflare-icon.86ac9d0b.svg";